import { render, staticRenderFns } from "./ProtocoloList.vue?vue&type=template&id=507c3046"
import script from "./ProtocoloList.vue?vue&type=script&lang=js"
export * from "./ProtocoloList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports